"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.featureFlagEnumReverse = exports.featureFlagEnum = void 0;
const featureFlagEnum = {
  CLONE_EXPERIMENT: 1,
  SAMPLE_SIZE_CALCULATOR: 2,
  DYNAMIC_TECH_SETTINGS: 3,
  EXPERIMENT_EVALUATION: 4,
  QUANTUM_METRICS: 5,
  LEARN_WIKI: 6,
  CI_IN_RESULTS: 7,
  ORM_2: 8,
  CMS_EXPERIMENTATION: 9,
  CMS_EXPERIMENT_RESET: 10,
  EXCLUSIVE_EXPERIMENTS: 11,
  CONTENT_MAP: 12,
  INTERNAL_ACTIVATION_EVENTS: 13,
  RULE_BUILDER_DISABLE_BUILD: 14,
  DATA_SCIENCE_CONTACT: 15
};
exports.featureFlagEnum = featureFlagEnum;
const featureFlagEnumReverse = {
  1: 'CLONE_EXPERIMENT',
  2: 'SAMPLE_SIZE_CALCULATOR',
  3: 'DYNAMIC_TECH_SETTINGS',
  4: 'EXPERIMENT_EVALUATION',
  5: 'QUANTUM_METRICS',
  6: 'LEARN_WIKI',
  7: 'CI_IN_RESULTS',
  8: 'ORM_2',
  9: 'CMS_EXPERIMENTATION',
  10: 'CMS_EXPERIMENT_RESET',
  11: 'EXCLUSIVE_EXPERIMENTS',
  12: 'CONTENT_MAP',
  13: 'INTERNAL_ACTIVATION_EVENTS',
  14: 'RULE_BUILDER_DISABLE_BUILD',
  15: 'DATA_SCIENCE_CONTACT'
};
exports.featureFlagEnumReverse = featureFlagEnumReverse;